import React from 'react';
import { FormattedMessage } from 'react-intl';
import CustomToolTip from '../../../../../../ui/CustomToolTip';
import * as Styled from './styled';

const ValidUntilToolTip = () => {
  return (
    <CustomToolTip
      id="CustomToolTip-validUntil"
      trigger={<Styled.HeaderIcon name="info-circle" />}
    >
      <Styled.ToolTipContentWrapper>
        <FormattedMessage
          id="The end date of the document must be earlier than or the same as the retention date of the document"
          defaultMessage="The end date of the document must be earlier than or the same as the retention date of the document"
        />
      </Styled.ToolTipContentWrapper>
    </CustomToolTip>
  );
};

export default ValidUntilToolTip;
